module.exports = __webpack_public_path__ + "static/media/tiffinfinds.ea3920ed.png";